import { gql } from '@apollo/client';

export const ProposalBuildInputFragment = gql`
  fragment ProposalBuildInputFragment on GraphVariant {
    id
    latestLaunch {
      id
      buildInput {
        ... on CompositionBuildInput {
          subgraphs {
            hash
            name
          }
        }
      }
    }
  }
`;

export type DrawerVisibilityState =
  | 'none'
  | 'comment'
  | 'linter'
  | 'unattributedDiagnostics';
